function resolveApiBase() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host && host !== 'localhost' && host !== '127.0.0.1') {
      return '';
    }
  }

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  return 'http://localhost:5002';
}

const isDev = process.env.NODE_ENV === 'development';
const API_BASE_URL = resolveApiBase();

const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAIZyMqh-Khi922yTjF2DZsEXD0YIykrU8',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'tosolhybrid.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'tosolhybrid',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'tosolhybrid.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '591912198460',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:591912198460:web:5e805f4541a96e1e78be39',
  vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || null,
};

module.exports = {
  API_BASE_URL,
  FIREBASE_CONFIG,
  isDev,
  resolveApiBase,
};
